import { PermissionsEnum } from '@/auth/interfaces';
import { useCheckPermissions } from '@/shared';
import SaveEmpresa from '../../shared/components/SaveEmpresa/SaveEmpresa';

export interface CreateEmpresaPageProps {}

const CreateEmpresaPage: React.FC<CreateEmpresaPageProps> = () => {
  useCheckPermissions(PermissionsEnum.api_add_empresa);

  return <SaveEmpresa titlePage="Crear Empresa" />;
};

export default CreateEmpresaPage;
